
/*========================================
        Imports!!!
=========================================*/

/*--BrowserRouter--*/
import { Link, useNavigate } from 'react-router';

/*--css--*/
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--logo--*/
import logo from '../assets/img/logo.webp';

/*========================================
        Functions!!!
=========================================*/
function LinkToContact() {
    const navigate = useNavigate();
  
    const handleClick = () => {
      navigate('/');
      navigate('/#Contact');
    };
  
    return (
      <button onClick={handleClick}>O nas</button>
    );
  }
  
  function LinkToProducts() {
    const navigate = useNavigate();
  
    const handleClick = () => {
      navigate('/');
      navigate('/#Products');
    };
  
    return (
      <button onClick={handleClick}>Produkty</button>
    );
  }


/*========================================
        Header!!!
=========================================*/

function Header(){
    return (
      <>
      {/*====Header====*/}
      <header>
        <Row className='p-4'>
          {/*----Logo----*/}
          <Col xl={8} lg={7} md={6}>
            <div className='Logo'>
                <Link to="/" reloadDocument={true}>
                  <Row>
                    <Col lg={1} md={2} xs={2} className='log'>
                      <img src={logo} alt='logo' />
                    </Col>
                    <Col  lg={10} md={9} xs={9} className='log textlog'>
                      Fortiq
                    </Col>
                  </Row>
                </Link>
            </div>
          </Col>
          {/*----Tabs----*/}
          <Col xl={4} lg={5} md={6} className='log'>
            <Row className='Tabs'>
              <Col lg={3} md={3} xs={3} className='Tcol'>
                <a href='#About' >
                  <LinkToContact />
                </a>
              </Col>
              <Col lg={3} md={3} xs={3} className='Tcol'>
                <a href='#Products'>
                  <LinkToProducts />
                </a>
              </Col>
              <Col lg={3} md={3} xs={3} className='Tcol'>
                <a href='#Contact'>
                  <button >Kontakt</button>
                </a>
              </Col>
              <Col lg={3} md={3} xs={3} className='Tcol'>
                  <Link to="/blog" reloadDocument = {true}>
                    <button >Blog</button>
                  </Link>
              </Col>
            </Row>
          </Col>
        </Row>
        </header >
      </>
    );
  }
  

export default Header;